<template>
  <div class="modul">
    <div class="modul-top">
      <div class="caidan-img">
        <img src="../../../assets/image/caidan.png" alt="菜单" />
      </div>
      <div class="caidan-title">用户管理</div>
      <el-select v-model="value" filterable placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <div class="modul-search">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="用户名称">
          <el-input
            v-model="formInline.accountName"
            clearable
            placeholder="请输入用户名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input
            v-model="formInline.phoneNum"
            clearable
            placeholder="请输入手机号码"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="是否启用">
          <el-select v-model="formInline.isEnable"
                     clearable
                     placeholder="请选择">
            <el-option label="是"
                       :value=1></el-option>
            <el-option label="否"
                       :value=0></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="创建时间">
          <el-date-picker v-model="formInline.value1"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          type="daterange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
      <div>
        <el-button @click="addItem">新增</el-button>
        <!-- <el-button @click="exportItem">导出</el-button> -->
      </div>
    </div>
    <div class="modul-content">
      <el-table
        ref="multipleTable"
        v-loading="loading"
        :data="tableData"
        :header-cell-style="{'text-align': 'center'}"
        :cell-style="{'text-align': 'center'}"
        max-height="calc(100vh - 350px)"
        border
        style="width: 100%"
      >
        <el-table-column label="编号" type="index"> </el-table-column>
        <el-table-column label="用户名称" prop="accountName"> </el-table-column>
        <!-- <el-table-column label="区域"
                         prop="quyu">
        </el-table-column> -->
        <el-table-column label="手机号码" prop="phoneNum"> </el-table-column>
        <el-table-column label="邮箱" prop="email"> </el-table-column>
        <el-table-column label="角色" prop="roleList">
          <template slot-scope="scope">
            {{ getRoleName(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column label="是否启用" prop="zhangtai">
          <template #default="scope">
            <!--  inactive-color="#ff4949" -->
            <el-switch
              v-model="scope.row.zhangtai"
              disabled
              active-color="#1677FF"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createTime"> </el-table-column>
        <el-table-column label="操作">
          <template #default="scope">
            <div>
              <el-button type="text" @click="write(scope.row)">修改</el-button>
              <el-button type="text" @click="shanChu(scope.row)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器-->
      <div style="text-align: center; margin: 20px 0 0">
        <!--描述：分页-->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.current_page"
          :page-sizes="[10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000]"
          :page-size="pagination.per_page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    <!--  -->
    <el-dialog
      :modal-append-to-body="false"
      :visible.sync="addVisible"
      :close-on-click-modal="false"
      width="65%"
    >
      <div class="modul-top1" slot="title">
        <div class="caidan-img">
          <img src="../../../assets/image/caidan.png" alt="菜单" />
        </div>
        <div class="caidan-title">
          {{ title }}
        </div>
      </div>
      <div style="text-align: left">
        <el-form
          :inline="true"
          :rules="rules"
          label-width="150px"
          :model="dialogFormInline"
          ref="ruleForm"
          class="demo-form-inline"
        >
          <el-row>
            <el-form-item label="头像" prop="img">
              <el-upload
                class="avatar-uploader"
                :action="api + '/file/upload'"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <img
                  v-if="dialogFormInline.img"
                  :src="dialogFormInline.img"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="用户名称" prop="accountName">
                <el-input
                  v-model="dialogFormInline.accountName"
                  class="dia-input"
                  placeholder="请输入用户名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="账号" prop="accountNum">
                <el-input
                  v-model="dialogFormInline.accountNum"
                  class="dia-input"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="区域"
                            prop="region">
                <el-select v-model="dialogFormInline.region"
                           disabled
                           style="width: 460px;"
                           placeholder="区域模块暂未开发">
                  <el-option label="区域一"
                             value="shanghai"></el-option>
                  <el-option label="区域二"
                             value="beijing"></el-option>
                </el-select>
              </el-form-item> -->
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="手机号码" prop="phoneNum">
                <el-input
                  v-model="dialogFormInline.phoneNum"
                  class="dia-input"
                  placeholder="请输入手机号码"
                  :disabled="title == '添加用户' ? false : true"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="角色" prop="roleUuids">
                <el-cascader
                  v-model="dialogFormInline.roleUuids"
                  :options="roleList"
                  class="dia-input"
                  :props="roleListprops"
                  clearable
                ></el-cascader>
              </el-form-item>
              
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="用户密码"
                v-if="title == '添加用户'"
                prop="password"
              >
                <el-input
                  v-model="dialogFormInline.password"
                  class="dia-input"
                  placeholder="请输入用户密码"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所属部门">
                <el-select
                  v-model="dialogFormInline.departmentUuid"
                  filterable
                  clearable
                  placeholder="请选择"
                  class="dia-input"
                >
                  <el-option
                    v-for="(item, index) in departmentData"
                    :key="index"
                    :label="item.departmentName"
                    :value="item.departmentUuid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="邮箱" prop="email">
                <el-input class="dia-input" v-model="dialogFormInline.email"  placeholder="请输入邮箱"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="用户性别" prop="sex">
                <el-select
                  v-model="dialogFormInline.sex"
                  class="dia-input"
                  placeholder="请选择性别"
                >
                  <el-option label="男" :value="0"></el-option>
                  <el-option label="女" :value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否启用" prop="zhangtai">
                <el-switch
                  v-model="dialogFormInline.zhangtai"
                  active-color="#1677FF"
                ></el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input type="textarea"
                          :autosize="{ minRows: 4, maxRows: 8}"
                          placeholder="请输入备注"
                          style="width: 1100px;"
                          v-model="dialogFormInline.textarea1">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
        </el-form>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
        style="right: 20px; bottom: 20px; position: absolute"
      >
        <el-button type="primary" @click="dialogSure('ruleForm')"
          >确 定</el-button
        >
        <el-button @click="quXiao('ruleForm')">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import md5 from 'js-md5'
import axios from 'axios'
export default {
  name: 'ZuijiBridegIndex',

  data() {
    var checkPhone = (rule, value, callback) => {
      // 手机号验证
      if (!value) {
        return callback(new Error('手机号不能为空'))
      } else {
        const reg = /^1[3456789]\d{9}$/
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号'))
        }
      }
    }
    return {
      //
      options: [
        {
          value: 1,
          label: '浙江-建德'
        }
      ],
      value: 1,
      // 搜索form
      formInline: {},
      // 表格
      loading: true,
      tableData: [],
      // 分页器
      pagination: {
        total: 0,
        per_page: 10,
        from: 1,
        to: 0,
        current_page: 1 //当前页数
      },
      //
      roleList: [], //角色列表
      roleListprops: {
        label: 'roleName',
        children: 'childRole',
        value: 'roleUuid',
        leaf: 'leaf',
        multiple: true
      },

      // addVisible
      title: '',
      addVisible: false,
      dialogFormInline: {},
      rules: {
        accountName: [
          {
            required: true,
            message: '请输入用户名称',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: '请输入用户密码',
            trigger: 'blur'
          }
        ],
        phoneNum: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          {
            validator: checkPhone,
            trigger: 'blur'
          }
        ]
      },
      departmentData: []
      // departmentName:'',
    }
  },

  async mounted() {
    this.tableReq()
    this.getRoleList()
    this.getDepartment()
  },
  watch: {
    path(one, two) {
      this.formInline = {}
      // console.log(one, two);
      this.tableReq()
    }
  },
  computed: {
    path() {
      return this.$route.path
    },
    api() {
      return this.$config.host
    }
  },
  methods: {
    getRoleName(row) {
      let data = []
      if (row.roleList.length !== 0) {
        row.roleList.forEach((ele) => {
          data.push(ele.roleName)
        })
        return data.join(',')
      } else {
        return ''
      }
    },
    // 获取-部门名称列表
    async getDepartment() {
      let data = {
        pageSize: 99999,
        pageNum: 1
      }
      const res = await this.$api.sendPost(
        '/enterpriseDepartment/getAllEnterpriseTWO',
        data
      )
      console.log('部门名称', res.data)
      if (res.errcode == 0) {
        if (res.data && res.data.length > 0) {
          this.departmentData = res.data
        } else {
          this.departmentData = []
        }
      }
    },
    handleAvatarSuccess(res, file) {
      // console.log(file);
      // this.dialogFormInline.img = URL.createObjectURL(file.raw);

      this.dialogFormInline.img = file.response.data.urlPath
      console.log(this.dialogFormInline.img)
    },
    beforeAvatarUpload(file) {
      console.log(file)
      const isPNG = file.type === 'image/png'
      const isJPG = file.type === 'image/jpeg'
      const isLt5M = file.size / 1024 / 1024 < 5
      // && !isJPG
      if (!isPNG && !isJPG) {
        this.$message.error('上传头像图片只能是 PNG 或 JPG 格式!')
      }
      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt5M) {
        this.$message.error('上传头像图片大小不能超过 5MB!')
      }
      //  && isJPG
      return isPNG && isLt5M
    },
    // 搜索
    onSubmit() {
      // console.log(JSON.parse(JSON.stringify(this.formInline)));
      this.tableReq(1)
    },
    // 新增
    addItem() {
      this.addVisible = true
      this.title = '添加用户'
      this.dialogFormInline = {
        accountName: '',
        accountNum: '',
        img: '',
        // region: '',
        phoneNum: '',
        roleUuids: '',
        // email: '',
        password: '',
        sex: '',
        // juese: '',
        isEnable: false,
        // textarea1: '',
        state: 1
      }
    },
    // 取消
    quXiao(formName) {
      this.addVisible = false
      if (this.title == '添加用户') {
        this.$refs[formName].resetFields()
      }
    },
    // 新增确认
    dialogSure(formName) {
      if (this.dialogFormInline.departmentUuid != '') {
        let add = this.departmentData.find((item) => {
          return this.dialogFormInline.departmentUuid == item.departmentUuid
        })
        // console.log(add);
        // this.dialogFormInline.departmentName = add.departmentName
      } else {
        // this.dialogFormInline.departmentName = ''
      }
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let dialogFormInline = JSON.parse(
            JSON.stringify(this.dialogFormInline)
          )
          console.log(this.dialogFormInline.roleUuids)
          let roleUuids = []
          if (this.dialogFormInline.roleUuids) {
            this.dialogFormInline.roleUuids.forEach((val) => {
              roleUuids.push(val[1])
            })
          }
          dialogFormInline.roleUuids = roleUuids
          if (this.dialogFormInline.zhangtai) {
            // console.log(1);
            dialogFormInline.isEnable = 1
          } else {
            // console.log(0);
            dialogFormInline.isEnable = 0
          }

          dialogFormInline.sex = Number(this.dialogFormInline.sex)

          if (this.title == '添加用户') {
            dialogFormInline.password = md5.hex(this.dialogFormInline.password)
          }
          console.log(dialogFormInline)
          const res = await this.$api.sendPost(
            '/accountInfo/insertOrUpdateAccountInfo',
            dialogFormInline
          )
          console.log(res)
          if (res.errcode === 0) {
            this.addVisible = false
            // console.log(res);
            this.tableReq()
          } else {
            this.$message.warning(res.errmsg)
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 导出
    // 导出事件
    exportItem() {
      axios({
        method: 'get',
        url: this.$config.host + '/wordReleaseOrder/exportExcel',
        params: {
          wordReleaseUuid: this.pagination.wordReleaseUuid,
          isAppointment: this.isAppointment
        },
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then((res) => {
          const link = document.createElement('a')
          let blob = new Blob([res.data], {
            type: 'application/vnd.ms-excel'
            // type: "application/pdf;charset=utf-8",  //.pdf
          })
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          link.download = '预约信息' + '.xls' //下载的文件名  注意：加.xls是兼容火狐浏览器
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
        .catch((error) => {
          // console.log(error)
        })
    },
    // 修改
    write(item) {
      this.title = '修改用户'
      this.addVisible = true
      // console.log(item);
      item.zhangtai = item.isEnable == 1 ? true : false
      this.dialogFormInline = item
      // 所属角色
      this.dialogFormInline.roleUuids = []
      if (
        this.dialogFormInline.roleList &&
        this.dialogFormInline.roleList.length !== 0
      ) {
        this.dialogFormInline.roleList.forEach((ele) => {
          this.roleList.forEach((item) => {
            let a = item.childRole.find((item2) => {
              return item2.roleUuid == ele.roleUuid
            })
            if (a) {
              this.dialogFormInline.roleUuids.push([
                item.roleUuid,
                ele.roleUuid
              ])
            }
          })
        })
      }
    },
    // 表格请求
    async tableReq(page) {
      this.loading = true
      if (page) {
        this.pagination.current_page = page
      }
      let data = {
        ...this.formInline,
        pageNum: this.pagination.current_page,
        pageSize: this.pagination.per_page
      }
      // console.log('表格参数', data);
      const res = await this.$api.sendPost(
        '/accountInfo/getAllAccountInfo',
        data
      )
      if (res.errcode === 0) {
        res.data.voList.map((item) => {
          item.zhangtai = item.isEnable == 1 ? true : false
        })
        this.loading = false
        this.tableData = res.data.voList
        this.pagination.total = res.data.total
        // console.log('表格数据', this.tableData);
      }
    },
    // 删除
    shanChu(item) {
      // console.log(item);
      this.$confirm('确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const res = await this.$api.sendGet('/accountInfo/dleteAccountInfo', {
            id: item.id
          })
          if (res.errcode == 0) {
            this.tableReq()
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 分页器----新每页条数
    handleSizeChange(val) {
      this.pagination.per_page = val
      this.tableReq(1)
    },
    // 分页器-----新当前页
    handleCurrentChange(val) {
      this.pagination.current_page = val
      this.tableReq()
    },
    // 角色列表
    async getRoleList() {
      const res = await this.$api.sendPost('/role/list', {})
      if (res.errcode === 0) {
        this.roleList = res.data.voList
        this.roleList.forEach((item) => {
          if (item.childRole == null || item.childRole.length == 0) {
            item.leaf = true
          } else {
            item.leaf = false
            item.childRole.forEach((ele) => {
              delete ele.childRole
              ele.leaf = true
            })
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// /deep/.el-input__inner {
//   border: none;
// }
.modul-search {
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

/deep/.el-dialog {
  height: 800px;
}

.avatar-uploader {
  border: 1px dashed #dcdfe6;
  text-align: left;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.dia-input {
  width: 400px;
}
</style>
